<template>
  <div>
    <v-combobox
      :append-icon="dropdownIcon"
      :class="{'v-input--is-hidden': disableAdd}"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :disabled="disabled"
      :error-messages="errorMessages"
      :hide-details="isSortable && !empty"
      :hide-no-data="!searchText"
      :items="items"
      :label="label"
      :search-input.sync="searchText"
      :value="value"
      @blur="onBlur"
      @change="onInput"
      @focus="onFocus"
      chips
      close
      data-vv-value-path="value"
      deletable-chips
      hide-selected
      multiple
      ref="selector"
      small-chips
      v-validate="validation"
    >
      <template slot="append">
        <v-tooltip bottom>
        <v-btn slot="activator" icon flat small class="nx-ui--level-2" @click="toggleDialog">
          <v-icon>assignment_add</v-icon>
        </v-btn>
          <span v-html="$t('message.form.stringArrayList.copyMultilineText')"></span>
        </v-tooltip>
      </template>
      <template slot="no-data">
        <v-list-tile>
          <span class="body-1" v-html="$t('message.form.fields.arraySelectorNoData')"></span>
          <v-chip small>{{ searchText }}</v-chip>
        </v-list-tile>
      </template>
      <template v-slot:selection></template>
    </v-combobox>
    <v-card flat style="margin-top: 1px;" class="mb-2" color="primary lighten-4" v-show="!empty">
      <v-card-text>
        <draggable @input="onInput" :value="value" class="nx-draggable-container d-flex d-flex--column">
          <v-chip v-for="(element, index) in value"
                  :key="`${index}-${element}`"
                  :close="!disableDelete"
                  @input="onChipInput(element)">
            <v-icon v-if="isSortable" small left>drag_indicator</v-icon>
            <span class="cursor-pointer" @click.prevent.stop="edit(index)">{{ element }}</span>
          </v-chip>
        </draggable>
      </v-card-text>
    </v-card>
    <nx-dialog v-model="editDialog" lazy max-width="400px" @input="commitEdit" icon="edit" :title="$t('message.form.stringArrayList.editElement')">
      <v-text-field v-if="editDialog" autofocus @keyup.enter.prevent.stop="commitEdit" v-model="editValue" />
    </nx-dialog>
    <nx-dialog :value="dialog" max-width="400px" icon="assignment_add" :title="$t('message.form.stringArrayList.copyMultilineText')">
      <v-textarea v-model="importItemText"
                  :placeholder="$t('message.form.stringArrayList.placeholder')"
                  @blur="commitEdit"
      ></v-textarea>
      <template slot="actions">
        <v-btn flat color="secondary" @click="addItem" v-text="$t('message.common.accept')"></v-btn>
        <v-btn flat color="primary" @click="toggleDialog" v-text="$t('message.common.cancel')"></v-btn>
      </template>
    </nx-dialog>
  </div>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxDialog from '@/components/dialogs/Dialog';
import draggable from 'vuedraggable';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'nx-form-sortable-string-array-list',
  mixins: [FormElement],
  components: {
    draggable,
    NxDialog,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    sortable: Boolean,
    disableAdd: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchText: '',
      dialog: false,
      importItemText: '',
      editIndex: null,
      editDialog: null,
      editValue: null,
    };
  },
  computed: {
    isSortable() {
      return !this.disabled && this.sortable;
    },
    dropdownIcon() {
      return (this.items.length > 0) ? 'arrow_drop_down' : null;
    },
  },
  methods: {
    edit(index) {
      this.editIndex = index;
      this.editValue = this.value[index];
      this.editDialog = true;
    },
    commitEdit() {
      if (!this.editDialog) {
        return;
      }
      const newValue = cloneDeep(this.value);
      if (this.editValue) {
        newValue.splice(this.editIndex, 1, this.editValue);
      } else {
        newValue.splice(this.editIndex, 1);
      }
      this.editValue = null;
      this.editDialog = null;
      this.onInput(newValue);
    },
    onChipInput(item) {
      const index = this.value.indexOf(item);
      const newValue = cloneDeep(this.value);
      newValue.splice(index, 1);
      this.onInput(newValue);
    },
    onInput(newValue) {
      this.$emit('input', newValue);
      this.$parentForm.updateField(this.name, newValue);
    },
    onBlur() {
      this.$emit('blur', true);
      this.flags.focused = false;
    },
    onFocus() {
      this.$emit('focus', true);
      this.flags.focused = true;
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    addItem() {
      let newArray = this.importItemText.trim().split('\n').filter(n => n);
      newArray = this.value.concat(newArray.map(n => n.trim()));
      this.onInput(newArray);
      this.dialog = false;
      this.importItemText = '';
    },
  },
};
</script>

<style lang="stylus">
.nx-draggable-container {
  .v-chip .v-chip__content {
    cursor: move;
  }
}
  .d-flex--column {
    flex-direction: column;

    .v-chip__content {
      display: flex;
      flex: 1 1 auto !important;
    }

    .v-chip__close {
      margin-left: auto;
    }
    .v-chip:not(.v-chip--removable) {
      .v-chip__content {
        justify-content: flex-start;
      }
    }
  }
  .v-text-field.v-input--is-hidden {
    .v-input__control {
      .v-input__slot {
        cursor: default;

        &:before {
          content: none;
        }
      }
      .v-label {
        position: relative!important;
      }
      .v-select__selections,
      .v-input__append-inner {
        display: none;
      }
    }
  }
</style>
